import { Subtle, Body1 } from '@xo-union/tk-ui-typography';
import { SetFieldValue } from '../../../gs-component-form';
import { RadioButton, MultiSelectGroup } from '@xo-union/tk-component-switches';
import { Field as FormikField } from 'formik';
import React, { ReactElement } from 'react';
import { compose } from '@xo-union/react-css-modules';

import RightRailSection from '../RightRailSection';
import styles from './eventVisibility.scss';

interface Props {
  setFieldValue: SetFieldValue;
  hasWWS: boolean;
  namePrefix?: string;
}

export const EventVisibility: React.FC<Props> = ({ hasWWS, setFieldValue, namePrefix = '' }: Props) => {
  const [selected, setSelected] = React.useState(new Set());
  if (!hasWWS) return null;
  // @ts-ignore
  const handleChange = (newValues): void => {
    setSelected(newValues);
  };

  return (
    <RightRailSection name="Event Access">
      <FormikField name={`${namePrefix}visible`}>
        {({ field }: { field: any }): ReactElement => (
          <MultiSelectGroup values={selected} onValuesChange={handleChange}>
            <div className={styles.radioButtonContainer}>
              <RadioButton
                value="open"
                checked={field.value}
                classes={compose({ container: styles.radioButton })}
                onClick={(): void => setFieldValue(`${namePrefix}visible`, true)}
              >
                <Body1>Open to all guests</Body1>
              </RadioButton>
              <Subtle className={styles.subText}>This event will appear on your Website&apos;s homepage.</Subtle>
            </div>
            <div className={styles.radioButtonContainer}>
              <RadioButton
                checked={!field.value}
                value="select"
                classes={compose({ container: styles.radioButton })}
                onClick={(): void => setFieldValue(`${namePrefix}visible`, false)}
              >
                <Body1>Open to select guests</Body1>
              </RadioButton>
              <Subtle className={styles.subText}>This event will only appear to guests when they RSVP.</Subtle>
            </div>
          </MultiSelectGroup>
        )}
      </FormikField>
    </RightRailSection>
  );
};
